import { useMemo } from 'react';

export const useFlattenCompanyList = (data) =>
  useMemo(
    () =>
      data?.ids
        ?.map((id) => data?.entities?.[id])
        .reduce((acc, company) => {
          const companiesGroup = [];

          if (company.contacts.length > 0) {
            company.contacts.forEach((contact) => {
              const temp = {
                rowId: `${company.id}-${contact.id}`,
                companyId: company.id,
                contactId: contact.id,
                introOffers: contact.introOffers ?? [],
                contact,
                company,
                ...company,
              };

              companiesGroup.push(temp);
            });
          } else {
            companiesGroup.push({
              ...company,
              rowId: `${company.id}-no-contacts`,
              noContacts: true,
              introOffers: [],
            });
          }

          if (companiesGroup.length > 0) {
            companiesGroup[companiesGroup.length - 1].lastGroupRow = true;
          }

          if (company.contactsCount > company.contacts.length) {
            companiesGroup.push({
              ...companiesGroup[0],
              id: 'load-more',
              rowId: `${company.id}-load-more`,
              contact: {
                fullName: 'Load more',
              },
            });
          }

          if (companiesGroup.length > 0) {
            companiesGroup[0].groupIndex = true;
          }

          if (company.contactsCount === 0) {
            companiesGroup[0].noContacts = true;
          }

          if (companiesGroup.length > 0) {
            companiesGroup[companiesGroup.length - 1].lastRow = true;
          }

          return [...acc, ...companiesGroup];
        }, []) ?? [],
    [data],
  );
